/* import __COLOCATED_TEMPLATE__ from './nexus-init-failure.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();